import { useEffect, useState } from "react";
import { STORIES } from "../data/site";

export const useSuccessStories = () => {
  const [stories, setStories] = useState(STORIES);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/store/success-stories`)
      .then((r) => r.json())
      .then((list) => { if (Array.isArray(list) && list.length > 0) setStories(list); })
      .catch(() => {});
  }, []);
  return stories;
};
